module.exports = function() {
  return new Worker(__webpack_public_path__ + "0870a7811de01dea99ca.worker.js");
};